export default __webpack_public_path__ + "static/media/BrainBreak cards106.4b538259.png";